module.exports = __webpack_public_path__ + "img/icon_laft.eb7a32f0.png";